import { useEffect, useState } from "react"
import CircleSwiper from "../CircleSwiper"
import apiEndpoint from "../../test/config"
const slika_url = 'https://picsum.photos/1920/1080'

function OstaliPredmeti() {
    let query = `{
        predmeti(first: 10) {
        edges {
            node {
            id
            predmet {
                icon {
                sourceUrl
                }
                imepredmeta
            }
            }
        }
        }
    }`

    const dataToVesti = (data) => {
        let sekcijaData = data.map((sekcija) => {
            return {
                id: sekcija['node']['id'],
                ime: sekcija['node']['predmet']['imepredmeta'],
                slika: sekcija['node']['predmet']['icon']['sourceUrl']
            }
        })
        setSekcije(sekcijaData)
        setUcitano(true)
    }
    const [sekcije, setSekcije] = useState([])
    const [ucitano, setUcitano] = useState(false)
    useEffect(() => {
        fetch(apiEndpoint,
            {
                method: 'POST',
                headers: {
                    "Content-Type": 'application/json',
                    "Accept": 'application/json'
                },
                body: JSON.stringify({
                    query
                })
            }).then((response) => response.json()).then((data) => {
                dataToVesti(data['data']['predmeti']['edges'])
            });
    }, []);

    return <>
        <div className="ostalo-osoblje-wrapper">
            {ucitano && <CircleSwiper
                naslov='Остали предмети'
                sviLink={{
                    tekst: 'Сви предмети',
                    link: 'http://localhost:3000/kolektiv'
                }}
                slikeImenaLinkovi={sekcije.map((x) => {
                    return {
                        slika: x['slika'],
                        ime: x['ime'],
                        link: `${window.location.origin}/predmet/${x.id}`
                    }
                })}
            ></CircleSwiper>}
        </div>
    </>
}

export default OstaliPredmeti